import { NAN_PARAMS, PARAMS_NAME } from "./config";
import { roundTo } from "../../Utils";

import React from 'react';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Graph from './components/Graph';
import Table from '../../components/StatsTable';
import Form from './components/Form';
import API from '../../services/API';

import moment from "moment";
import _ from "lodash";

class Bidder extends React.Component {
    constructor() {
        super();

        this.state = {
            params: [],
            paramsObj: {},
            report: [],
            total: {},
            isLoading: false,
            availableSources: [],
            availablePartners: [],
            graph: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        API.BidderSources.getAvailableSources().then((sources) => {
            sources.push('DEFAULT');

            this.setState({ availableSources: sources });
        })

        API.BidderPartners.getConfig().then(availablePartners => {
            this.setState({ availablePartners })
        })

        const date = new Date()
        const dateTo = date.toISOString().split('T')[0];

        date.setDate(date.getDate() - 8);

        const dateFrom = date.toISOString().split('T')[0];

        API.Bidder.getV2Graph({ dateFrom, dateTo }).then(({ graph }) =>
            this.setState({ graph }));
    }


    async handleSubmit(filters, checkboxes) {
        if (!filters.groupBy.length) return alert('Select at least one "Group By" param');

        this.setState({ isLoading: true });

        const promises = [
            API.Bidder.getV2(filters),
            API.Bidder.getV2Graph(filters),
        ];

        if (checkboxes.realtime) {
            promises.push(API.BidderRealtime.daily.get({ groupBy: filters.groupBy, country: filters.country, source: filters.source }));
        }

        await Promise.all(promises).then(([ { total, params, report }, { graph }, realtime ]) => {
            if (realtime && realtime.report && realtime.report.length) {
                total = _.reduce([ realtime.total, total ], (x, y) => _.mergeWith(x, y, (x, y, param) => {
                    // TODO: Recalculate business params when realtime report shown, line below returns values w/o realtime
                    if ([ 'cpc', 'eCpm', 'ctr', 'winsPercent' ].includes(param)) return y;

                    return roundTo(4, Number(x) + Number(y));
                }));

                report = [ ...report, ...realtime.report ];

                graph = [ ...graph, { day: `LIVE - ${moment().utc().format('YYYY-MM-DD')}`, ...realtime.total } ]
            }

            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, total, graph, isLoading: false };

            this.setState(newState)
        });
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return ( <Graph data={graph}/> );
    }

    render() {
        const { isLoading, availableSources, availablePartners, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder V2"/>

                <Form sources={availableSources} partners={availablePartners} onSubmit={this.handleSubmit}/>

                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default Bidder;



// WEBPACK FOOTER //
// ./src/scenes/BidderV2/index.js